import React from 'react';
import { useHistory } from 'react-router-dom';
import * as NotFoundImg from '@app/src/assets/img/not-found.png'
import { COLORS } from '@app/src/ui';
import {
  Img,
  Title,
  Text,
  Message,
  ButtonWrapper,
  CentralHelp,
  Container
} from './styled';

export const NotFound: React.FC = () => {
  const history = useHistory();

  const handleClick = () => {
    history.push('/');
  }

  return (
    <Container>
      <Img src={NotFoundImg} />
      <Title>
        La página a la que está intentando acceder no existe o se ha movido.
      </Title>
      <Message>Intenta volver a nuestra página principal.</Message>
      <ButtonWrapper
        background={COLORS.YELLOW_GENERIC}
        color="#000"
        text="Página principal"
        handleClick={handleClick}
        width={280}
      />
      <Text>
        Si necesitas ayuda para publicar un aviso, recuerda que puedes contactarnos por medio de la <CentralHelp href="https://centraldeayuda.clasificados.pe/hc/es/requests/new" target="_blank">Central de Ayuda</CentralHelp>
      </Text>
    </Container>
  )
};